import { Exact } from "src/generated/graphql";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query } from "apollo-angular";
import { ScoringCriteria } from "./scoringCriteria.graphql";

export type GetScoringCriteriaQueryVariables = Exact<{ [key: string]: never }>;

export type GetScoringCriteriaQuery = {
    getScoringCriterias: [ScoringCriteria];
};

export const GetScoringCriteriaDocument = gql`
  query GetScoringCriterias {
    getScoringCriterias {
      id
      remunerationId
      scoreLevelId
      minValue
      maxValue
      points
      remuneration {
        id
        name
      }
      scoreLevel {
        id
        levelName
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetScoringCriteriaGQL extends Query<
  GetScoringCriteriaQuery,
  GetScoringCriteriaQueryVariables
> {
  document = GetScoringCriteriaDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
